import { Component, DestroyRef, EventEmitter, Input, Output, ViewChild, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ModalComponent } from '@rn-platform/frontend-shared-ui-common';
import { ChangeOrganizationFolderDialogConfiguration } from './change-organization-folder-configuration.model';
import { ChangeOrganizationModalService } from './change-organization-modal.service';;
@Component({
  selector: 'app-change-organization-folder-dialog',
  templateUrl: './change-organization-folder-dialog.component.html',
  styleUrls: ['./change-organization-folder-dialog.component.scss'],
  standalone: false
})
export class ChangeOrganizationFolderDialogComponent implements OnInit {
  @ViewChild('modalRef') modalComponent: ModalComponent;
  @Output() confirmChange = new EventEmitter<ChangeOrganizationFolderDialogConfiguration>();
  actionTitle: string;
  originalName: string;
  newName: string;
  private readonly changeOrganizationModalService = inject(ChangeOrganizationModalService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.changeOrganizationModalService.modalState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {      
      if(!data) return;
      if (data?.config)
      {
          this._config = data.config;
          this.actionTitle = this._config.actionTitle;
          this.originalName = this._config.originalName;
          this.newName = this._config.newName;
      }
      if (data?.isOpen) {
        this.open();
      } else {
        this.close();
      }
    });
  }

  private _config: ChangeOrganizationFolderDialogConfiguration;

  @Input()
  set config(config: ChangeOrganizationFolderDialogConfiguration) {
    this._config = config;
    if (config) {
      this.actionTitle = config.actionTitle;
      this.originalName = config.originalName;
      this.newName = config.newName;
    }
  }
  get changeOrganizationFolderDialogConfig(): ChangeOrganizationFolderDialogConfiguration {
    return this._config;
  }

  public open(): void {
    this.modalComponent?.open();
  }

  public close(): void {
    this.modalComponent?.close();
  }

  public confirm(): void {
    this.confirmChange.emit(this.changeOrganizationFolderDialogConfig);
    this.modalComponent?.close();
  }
}
